import React from 'react';
import {Link} from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import {withStyles} from '@material-ui/core/styles';
import CancelRequestDetailTable from "./CancelRequestDetailTable";
import ApiFetcher from "../../ApiFetcher";
import Utility from "../../Utility";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    paper: {
        margin: theme.spacing.unit,
    },
    button: {
        width: '80%',
    },
    textField: {
        margin: 'auto',
        width: '80%',
    },
    buttonDiv: {
        margin: theme.spacing.unit,
    },
    circularProgress: {
        margin: theme.spacing.unit,
    },
    errorMessage: {
        color: 'red'
    }
});

export class CancelRequestDetail extends React.Component {
    constructor(props){
        super(props);

        let params = new URLSearchParams(this.props.location.search);
        this.objectId = params.get("objectId");
        this.state = {
            detail: null,
            cancelReason: "",
            submitError: [],
            isWaitGetRequestDispatch: true,
            isWaitSubmitEditRequestDispatch: false,
        };

        this.handleGetResponse = this.handleGetResponse.bind(this);
        this.submitApprove = this.submitApprove.bind(this);
        this.handleSubmitEditRequestDispatchResponse = this.handleSubmitEditRequestDispatchResponse.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('キャンセル要求詳細画面');
        }
    }

    componentDidMount(){
        ApiFetcher.getRequestDispatch(this.props.cookies.get('token'), this.objectId, this.handleGetResponse);
    }

    handleGetResponse(responseJson){
        this.setState({isWaitGetRequestDispatch: false});
        if(responseJson.message === null || responseJson.message === ""){
            this.setState({detail: responseJson.result});
        }
        else{
            // 想定されるエラーは以下の通り.
            // 画面が成立しないので前画面に戻す.
            // + トークン期限切れ
            // + 存在しないobjectIdを指定
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push(this.props.backPath); // ページ遷移.
        }
    }

    handleSubmitEditRequestDispatchResponse(responseJson){
        this.setState({isWaitSubmitEditRequestDispatch: false});
        if(responseJson.message === null || responseJson.message === ""){
            alert('キャンセル要求へ返答しました。');
            this.props.history.push(this.props.nextPath); // ページ遷移.
        }
        else{
            this.setState({submitError: responseJson.message});
        }
    }

    showApprove(){
        if(Utility.isBusinessPartnerRole(this.props.cookies.get('role')) && this.state.detail !== null && Utility.isUnapprovedCancelProgressStatus(this.state.detail.progressStatus)){
            if(this.state.isWaitSubmitEditRequestDispatch){
                return (<CircularProgress className={this.props.classes.circularProgress}/>);
            }

            return (
                <div>
                    <div>
                        <Grid container justify="center">
                            <Grid item xs={8}>
                                <Button className={this.props.classes.button} variant="contained" color="primary" onClick={this.submitApprove}>承認</Button>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            );
        }
        else {
            return null;
        }
    }

    submitEditRequestDispatch(progressStatus, cancelReason){
        this.setState({isWaitSubmitEditRequestDispatch: true}, () => {
            ApiFetcher.putEditRequestDispatch(
                this.props.cookies.get('token'),
                this.objectId,
                progressStatus,
                cancelReason,
                this.handleSubmitEditRequestDispatchResponse
            );
        });
    }

    submitApprove(){
        this.submitEditRequestDispatch(12, "");
    }

    static convertErrorMessagePropertyName(propertyName){
        if(propertyName === 'progressStatus'){
            return 'ステータス:';
        }
        else if(propertyName === 'cancelReason'){
            return '却下理由:';
        }
        else{
            return '';
        }
    }

    render(){
        const ButtonLink = props => <Link to={this.props.backPath} {...props} />;
        return (
            <div className={this.props.classes.root}>
                <Paper className={this.props.classes.paper}>
                    {this.state.isWaitGetRequestDispatch === true && <CircularProgress className={this.props.classes.circularProgress}/>}
                    {this.state.isWaitGetRequestDispatch === false && <CancelRequestDetailTable detail={this.state.detail}/>}
                </Paper>
                <div>
                    {this.state.submitError.map((row, i) =>{
                        return (
                            <div key={i} className={this.props.classes.errorMessage}>
                                {CancelRequestDetail.convertErrorMessagePropertyName(row.propertyName)}{row.errorMessage}
                            </div>
                        )
                    })}
                </div>
                {this.showApprove()}
                <div className={this.props.classes.buttonDiv}>
                    <Button variant="contained" color="primary" component={ButtonLink} fullWidth>一覧へ戻る</Button>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(CancelRequestDetail);